import {LocationPoint} from '@/common/interfaces/location';
import {ClockType, PressureUnit, SpeedUnit, TemperatureUnit} from '@/common/constants/units';

export const initialState = {
	locations: <Pick<LocationPoint, 'id' | 'title'>[]>[],
	sizeType: <'adaptive' | 'fixed'>'adaptive',
	layout: <'vertical' | 'horizontal'>'horizontal',
	width: 170,
	language: 'uk', // Will be changed to  a primary domain language
	showWindSpeed: true,
	showHumidity: true,
	showPressure: true,
	showPrecipitation: false,
	timeFormat: ClockType['24h'],
	temperatureUnit: TemperatureUnit.celsius,
	pressureUnit: PressureUnit.mmHg,
	windSpeedUnit: SpeedUnit.ms,
	fontFamily: 'Arial',
	theme: <'light' | 'dark' | 'custom'>'light',
	customFirstBgColor: {r: 255, g: 255, b: 255, a: 1},
	customSecondBgColor: {r: 236, g: 236, b: 236, a: 1},
	customFirstTextColor: {r: 0, g: 0, b: 0, a: 1},
	customSecondTextColor: {r: 171, g: 173, b: 179, a: 1},
	customIconsColor: {r: 0, g: 138, b: 255, a: 1},
	email: '',
};

export type InformerConfigState = typeof initialState;

export type Action =
	| {
			type: 'setValues';
			values: Partial<InformerConfigState>;
	  }
	| {
			type: 'addLocation';
			location: LocationPoint;
	  }
	| {
			type: 'removeLocation';
			index: number;
	  }
	| {
			type: 'replaceLocation';
			location: LocationPoint;
			index: number;
	  }
	| {
			type: 'reset';
	  };

export function informerConfigReducer(state: InformerConfigState, action: Action) {
	switch (action.type) {
		case 'setValues':
			return {...state, ...action.values};

		case 'addLocation':
			return {
				...state,
				locations: [...state.locations, action.location],
			};

		case 'removeLocation': {
			const locations = state.locations.slice();
			locations.splice(action.index, 1);
			return {...state, locations};
		}

		case 'replaceLocation': {
			const locations = state.locations.slice();
			locations.splice(action.index, 1, action.location);
			return {...state, locations};
		}

		case 'reset':
			return {...initialState};
	}
}
